'use strict';
/**
 * @ngdoc function
 * @name thothAppApp.directive:googlePicker
 * @description
 * # googlePicker
 * Directive to generate a googlePicker UI element
 */
angular.module('thothApp.directives')
.directive('googlePicker', function() {
  return {
    restrict: 'E',
    templateUrl: 'views/_google-picker.html'
  };
});
